import { store } from '../../../app/stores/store';
import { v4 as uuid } from 'uuid';
// import { MetaDataElement, MetaDataOptions } from "../../../app/models/metaDataConfig";
// import sendRespectiveEmail from "../../../app/models/EmailNew";
// import { toast } from "react-toastify";
import {
  WorkFlowSubTasks,
  Communication,
  WorkflowElement,
  WorkflowOptions,
  tempApi,
} from '../../../app/models/template';
import { FileUploadInterface } from '../../../app/models/Profile';
import agent from '../../../app/api/agent';
import { toast } from 'react-toastify';
import { SimpleHistoryReturn } from '../../../app/models/history';
import { metadataType } from '../../../app/api/types';

async function SectionsPostMultiple(
  exportData: any,
  activity: any,
  index: number,
  totalLength: number,
  metadata: metadataType[],
  nfiaParentId: string,
) {
  // eslint-disable-next-line
  if (exportData) {
    store.activityStore.loadingInitialSections = true;
    const items: any = [];
    const sectionsMultipleID = activity?.id + '/' + activity?.title;
    const generatedID = exportData.id;
    let currentTaskData = '';
    let currentSubTaskData = '';

    if (exportData?.orders?.[0]) {
      let orderDataTemplate =
        exportData?.orders[0]?.itemOrderReceiving[0]?.receivingWorkflows[0];
      orderDataTemplate.templateId = uuid();

      orderDataTemplate.tasks?.forEach((task: any) => {
        task.taskId = uuid();

        task?.subTasks?.forEach((subtasks: WorkFlowSubTasks) => {
          subtasks.subTaskId = uuid();
          subtasks?.communication?.forEach((communication: Communication) => {
            communication.id = uuid();
          });
          subtasks?.api?.forEach((tempApi: tempApi) => {
            tempApi.id = uuid();
          });
          subtasks?.elements?.forEach((element: WorkflowElement) => {
            element.elementId = uuid();
            element?.options?.forEach((options: WorkflowOptions) => {
              options.optionId = uuid();
            });
            element?.files?.forEach((File: FileUploadInterface) => {
              File.id = uuid();
            });
            element?.photos?.forEach((photos: FileUploadInterface) => {
              photos.id = uuid();
            });
          });
        });
      });
      for (let i = 0; i < orderDataTemplate.tasks?.length; i++) {
        //setting the current task and subtask
        if (orderDataTemplate.tasks[i].isActive === true) {
          orderDataTemplate.tasks[i].isCurrentTask = true;
          currentTaskData = orderDataTemplate.tasks[i].taskName; //setting the task name for update
          const subtaskDetail = orderDataTemplate.tasks[i].subTasks;
          for (let i = 0; i < subtaskDetail.length; i++) {
            if (subtaskDetail[i].isActive === true) {
              subtaskDetail[i].isCurrentSubtask = true;
              currentSubTaskData = subtaskDetail[i].subTaskName; //setting the task name for update
              break;
            }
          }
          break;
        }
      }
    }
    const tempMet = exportData.metadata?.map((childM: any) => {
      if (
        childM.elementType === 'metadataFromParent' &&
        childM.elementValue === ''
      ) {
        let temp = {};
        metadata?.forEach((parentM: metadataType) => {
          if (
            parentM.elementName === childM.metadataFromParent.split('|')?.[2]
          ) {
            temp = {
              ...childM,
              elementValue: parentM.elementValue,
            };
          }
        });
        return temp;
      } else {
        return childM;
      }
    });
    const item = {
      ...exportData,
      id: generatedID,
      departmentId: store.activityStore?.sectionOrderDepartmentId,
      departmentName: store.activityStore?.sectionOrderDepartmentName,
      type: exportData.type,
      element: exportData.element,
      current_task: currentTaskData,
      current_subtask: currentSubTaskData,
      current_user: store?.userStore?.user?.customerName,
      year: store.dashboardStore.dashboard.dashboardWorkLevelMaster.year,
      originIndia:
        store.dashboardStore.dashboard.dashboardWorkLevelMaster.originIndia,
      title: exportData.title,
      language:
        store.dashboardStore.dashboard.dashboardWorkLevelMaster.language,
      number_of_element: exportData.number_of_element,
      asset_tracking_status: store.dashboardStore.dashboard.CreateOrderTemplate
        ? 'Receiving Order Created'
        : 'New Asset Titles Added This Month',
      order_tracking: 'Received',
      physical_sensor_barcode: generatedID,
      physical_location_rack: activity.physical_location_rack,
      physical_location_shelf: activity.physical_location_shelf,
      physical_location_vault: activity.physical_location_vault,
      global_positioning_system: activity.global_positioning_system,
      physical_sensor_RFID: generatedID,
      physical_sensor_qrcode: generatedID,
      receivingdate: new Date().toISOString(),
      itemCreatedAt: new Date().toISOString(),
      last_modified: new Date().toISOString(),
      movementdate: new Date().toISOString(),
      maintenance: new Date().toISOString(),
      status_Time: new Date().toISOString(),
      assignedUsers: [
        {
          appUserId: store.userStore.user?.id,
          itemLevelId: generatedID,
          isHost: true,
        },
      ],
      itemHistory: [
        SimpleHistoryReturn(
          exportData.title,
          // store.userStore.user?.customerName === 'Restoration'
          //   ? 'through Import Cutlist'
          //   : 'through sections multiple',
          `from ${activity?.title}`,
          generatedID,
        ),
      ],
      certification_date: new Date().toISOString(),
      year_reference: new Date().toISOString(),
      metadata: tempMet,
      parent: nfiaParentId ? (exportData?.parent.includes(undefined) ? sectionsMultipleID : exportData?.parent) : sectionsMultipleID,
      isReceivingOrder: store.dashboardStore.dashboard.CreateOrderTemplate
        ? true
        : false,
      isReceiving: store.dashboardStore.dashboard.CreateOrderTemplate
        ? true
        : false,
      itemCreatedBy: store.userStore.user?.customerName,
      orders: exportData.orders || [],
      status: 'Yet to Start',
    };
    item?.metadata?.forEach((_data: any, i: number) => {
      item.metadata[i].elementId = uuid();
      item.metadata[i]?.options?.forEach((_data: any, j: number) => {
        item.metadata[i].options[j].optionId = uuid();
      });
    });
    if(store.userStore.user?.customerName ==='NFAIReport'){
      const index =  item.metadata.findIndex((e:any) => e.elementName === "Film_Title")
      if(index !== -1){
       item.metadata[index].elementValue = activity.title?.split('-')[1].trim();
      }  
    } 

    items.push(item);
    store.dashboardStore.createorderTemplatedata(
      store.dashboardStore.dashboard.CreateOrderTemplate,
    );

    if (store.WorkLevelStore.selectedworkLevel !== undefined) {
      const data: any = {
        ...store.dashboardStore.dashboard.dashboardWorkLevelMaster,
        items,
      };
      const HistoryArr2: any = {
        id: activity!.id,
        itemHistory: [
          SimpleHistoryReturn(
            items[0].title,
            `from ${activity?.title}`,
            activity.id,
          ),
        ],
      };
        if(store.userStore?.user?.customerName === 'PCPLCRM' && store.userStore?.user?.roleName === 'IT Team'){
          const NewAssetTagIndex = item.metadata.findIndex((e:any) => e.elementName === "New Asset Tag");
          const QR_codeIndex = item.metadata.findIndex((e:any) => e.elementName === "QR code");
         if(NewAssetTagIndex !== -1) item['physical_sensor_barcode'] = item.metadata[NewAssetTagIndex].elementValue;
         if(QR_codeIndex !== -1) item['physical_sensor_qrcode'] = item.metadata[QR_codeIndex].elementValue
        }
      try {
        if (nfiaParentId) {
          await agent.NFAI.postCutlist(
            store.dashboardStore.dashboard.dashboardWorkLevelMaster?.id,
            item,
          ).then(async () => {
            const count = store.viewStore.unAssignedUsersCount;
            const params1 = {
              itemId: activity?.id,
              displayName: '',
              pageNo: 1,
              pageSize: Math.round(count),
            };
            await agent.viewPage
              .unAssignedUsersList(params1)
              .then((Response) => {
                const storeList = store.viewStore;
                const JionArr = Response.data.concat(storeList?.assignedUsers);
                const filteredUserId = JionArr?.filter(
                  (list: any) =>
                    list.displayname?.trim() ===
                    exportData?.displayname?.trim(),
                );
                const params = {
                  itemId: item?.id,
                  userId: filteredUserId[0]?.id,
                };
                if(exportData?.displayname?.trim() !== store.userStore.user?.displayName?.trim()){
                  storeList.addUserToItem(params, exportData?.displayname, false);
                }
              });
          });
        } else {
          await agent.WorkLevels.updateItemLevel(data);
        }
        let orderDataTemplate =
          exportData?.orders[0]?.itemOrderReceiving[0]?.receivingWorkflows[0];
        let activetasks = orderDataTemplate?.tasks?.filter(
          (data: { isActive: string }) => data.isActive,
        );
        await agent.WorkLevels.updateProductionCountViaSections(
          activetasks?.length || 0,
        );
        store.activityStore.loadSectionsData = `${index}/${totalLength - 2}`;
        // store.mediaAssetStore.setOpenSectionsMultiple(false)
        store.activityStore.loadingInitialSections = false;
        // store.dashboardStore.updateCreateOrderTemplate(undefined);
        agent.Activities.onlyHistory(activity!.id, HistoryArr2); //for Parent
        agent.Reports.metadataHeadersPostItemID(generatedID); //To Update MetaData Header Table
        toast.success('Item Created Successfully');
        store.dashboardStore.updateCreateOrderTemplate(
          store.dashboardStore.dashboard.CreateOrderTemplate1,
        );
      } catch (error) {
        store.activityStore.loadingInitialSections = false;
      }
      // this.selectedActivity=WorkLevel.items[0];
    }
  }
}

export default SectionsPostMultiple;
